import React, {forwardRef} from 'react';
import cn from 'classnames';
import styles from './FieldText.css';

const sizeTypeStyles = {
	medium: styles.sizeCompact,
	large: styles.sizeMedium,
};

type NativeInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export interface FieldTextProps extends NativeInputProps {
	sizeType?: 'medium' | 'large';
	failed?: boolean;
}

export const FieldText = forwardRef<HTMLInputElement, FieldTextProps>((props, ref) => {
	const {className, sizeType = 'medium', failed, ...nativeProps} = props;

	return (
		<input
			ref={ref}
			className={cn(styles.root, sizeType && sizeTypeStyles[sizeType], failed && styles.isFailed, className)}
			type='text'
			{...nativeProps}
		/>
	);
});

FieldText.displayName = 'FieldText';
